import React from 'react'
import { Row, Col, Card, Button } from 'antd';
import { FaEnvelope, FaMapMarkerAlt, FaPhone } from "react-icons/fa";

function TermsConditions() {
    return (
        <>

            <section className='informationBanner'>
                <div className='container'>
                    <Row gutter={16} align="middle">
                        <Col md={16} sm={24}>
                            <div className='Package-cntr'>
                                <h2 className=''>Contact Us</h2>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className='contact-area'>
                <div className='container'>
                    <Row gutter={16}>
                        <Col md={24}>
                            <Card className='my-5'>
                                <Row gutter={16}>
                                    <Col md={14}>
                                        <h2 className='mb-3 bottom'>Drop A Message</h2>
                                        <Row gutter={16}>
                                            <Col md={12} xs={24}>
                                                <div className='form-group'>
                                                    <label htmlFor="Name">Name</label>
                                                    <input type="text" name="" id="" className='form-control' />
                                                </div>
                                            </Col>
                                            <Col md={12} xs={24}>
                                                <div className='form-group'>
                                                    <label htmlFor="Email">Email</label>
                                                    <input type="text" name="" id="" className='form-control' />
                                                </div>
                                            </Col>
                                            <Col md={12} xs={24}>
                                                <div className='form-group'>
                                                    <label htmlFor="Phone">Phone</label>
                                                    <input type="text" name="" id="" className='form-control' />
                                                </div>
                                            </Col>
                                            <Col md={12} xs={24}>
                                                <div className='form-group'>
                                                    <label htmlFor="Subject">Subject</label>
                                                    <input type="text" name="" id="" className='form-control' />
                                                </div>
                                            </Col>
                                            <Col md={24} xs={24}>
                                                <div className='form-group'>
                                                    <label htmlFor="Message">Your Message</label>
                                                    <input type="text" name="" id="" className='form-control' />
                                                </div>

                                                <Button className='btn btn-primary mt-3' style={{ height: '40px', width: '120px' }} aria-label="send now">Send Now</Button>
                                            </Col>
                                        </Row>

                                        <hr className='my-3' />

                                        <h2 className='mb-3 bottom'>Get In Touch</h2>
                                        <Row gutter={16}>
                                            <Col md={24} className='mb-2'>
                                                <FaMapMarkerAlt className='float-start GetTouch me-2 mt-1' />
                                                SuperbWorldTrip Pvt. Ltd., Second floor, Rear Wing Nehru House, 4 Bahadur Shah Zafar Marg , Near ITO Metro Station Gate no. 4 ITO, New Delhi -110002
                                            </Col>
                                            <Col md={24} className='mb-2'>
                                                <FaEnvelope className='float-start GetTouch me-2' />
                                                flightbooking@SuperbWorldTrip.com
                                            </Col>
                                            <Col md={24}>
                                                <FaPhone className='float-start GetTouch me-2' />
                                                <span>
                                                    +91-9312241999,  +91-11-41855999,  Fax : +91-11-23350999
                                                </span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={10}>
                                        <h2 className='mb-3 bottom'>Office Location</h2>
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14007.92383204068!2d77.2415974!3d28.6303328!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x91a5c846909a7809!2sSuperbWorldTrip!5e0!3m2!1sen!2sin!4v1556512343093!5m2!1sen!2sin" frameborder="0" style={{ width: '100%', height: '90%' }}></iframe>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map marker">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Ahmedabad</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>B-236, 2nd Floor, Sakar-7,
                                        Nehru Bridge Corner,
                                        Ashram Road, Ahmedabad, Gujarat 380009.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>ahmedabad@seplgroup.com,<br />
                                                bm.ahmedabad@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-762-400-0990</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="marker">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Hyderabad</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>5-9-18/9, 1st Floor, Opp. Secretariat, Old Gate, Saifabad, Telangana 500004.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>hyderabad@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-9030088551</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Bhopal</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>Office No.104, Sharma Tower, 1st Floor 45 Rachna Nagar I, Bhopal, Madhya Pradesh 462023.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>bhopal@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-738-976-0450</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="locaiton">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Chandigarh</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>SCO-52, Office No. 06, Basement, Sector-9 D, Chandigarh - 160009.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>chandigarh@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> ++91-931-927-6985</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Chennai, Tamilnadu</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>No: B 1, "Prince Manor" 114, Purasawalkam High Road, Chennai, Tamil Nadu 600010.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>chennai@seplgroup.com, sales@SuperbWorldTrip.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-988-454-5635</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Goa</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>G-10, ground floor, Gera Imperium 1 EDC patto,Panaji, Goa 403001.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>goa@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-788-804-7640</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Bangalore</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>Office No. 305, 3rd Floor, 92,Kedia Arcade,
                                        Opposite Guardian Bank, Infantry Road, Bangalore, Karnataka 560001.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>bangalore@seplgroup.com,
                                                bbm@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-805-000-1255</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Jalandhar</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>Office no. 309,Second Floor Prestige Chamber, Opp.
                                        Narinder Cinema Near Bus Stand, Jalandhar, Punjab 144001.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>jalandhar@seplgroup.com, prakash.s@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-9319276981</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Jaipur</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>Office No. 204, RK Tower, Niwas Marg, Bani Park, Jaipur, Rajasthan 302016.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>jaipur@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-9810603888</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Kochi, Kerala</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>53/54, First Floor, D D Corner Stone Building, Kadavanthra Junction,
                                        Ernakulam, Kerala 682020.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>cochin@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-7510560002</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Kolkata</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>52A, Shakespeare Sarani 1st floor
                                        Chandan Niketan, Near Trimurti HP petrol pump
                                        and Beckbagan Crossing, Kolkata, West Bengal 700017.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>kolkata@seplgroup.com, bm.kolkata@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-759-609-9902</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Lucknow</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>G 49 Tej kumar plaza, Opp Darul safa, 1 Triloki Nath Road, Hazrat Ganj, Lucknow, Uttar Pradesh 226001.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>lucknow@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-730-391-6290</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Mumbai</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>No. 41/42, Ground Floor, Ashoka Shopping centre,
                                        Near G.T. Hospital, Lokmanya, Tilak Rd, Lohar Chawl, Kalbadevi, Mumbai, Maharashtra 400001.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>mumbai@seplgroup.com, bm.mumbai@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-986-730-6888</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Patna</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>Shop No. 1, 1st Floor, Hurmat Complex,
                                        Khagaul Rd, near Mahavir Cancer Sansthan, B Sector, Phulwari Sharif, Patna, Bihar 801505.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>patna@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-9319096918</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Pune, Maharashtra</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>Office No.-101, 1st Floor, City Mall,
                                        Near Savitribai Pune University Circle, Pune, Maharashtra 411007</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>pune@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-931-940-0306</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>Trivandrum, Kerala</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>T.C No. 26/1303/1 Ground Floor Welmen Centre Panavila Junction, Trivandrum - 695001.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>btvm@seplgroup.com, jins@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> +91-773-656-0004</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                        <Col md={12}>
                            <Card className='mb-3'>
                                <div className='text-center'>
                                    <Button className='btn btn-primary' aria-label="map">
                                        <FaMapMarkerAlt />
                                    </Button>

                                    <h2>SEPL Document Clearing LLC, Dubai</h2>
                                </div>
                                <div className='ms-md-3 ps-md-3 border-md'>
                                    <h2>Superb World Trip</h2>
                                    <p className='mb-2'>101 First Floor, Khalid Bin Al Waleed Building, Khalid Bin Al Waleed Road,
                                        Sharaf DG Metro Station Exit 3, Dubai - United Arab Emirates.</p>
                                    <ul>
                                        <li className='d-flex align-items-center gap-2'>
                                            <FaEnvelope />
                                            <span>dubai@seplgroup.com</span>
                                        </li>
                                        <li className='d-flex align-items-center gap-2'><FaPhone /> ++971-502447519, +971-544609354</li>
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </section>

        </>
    )
}

export default TermsConditions